import queryStringBuilder from '../../utils/queryStringBuilder';

const API_URL = process.env.API_URL;
const jwt = () => localStorage.getItem('jwt');

export const getProgrammes = (options = {}) =>
    fetch(`${API_URL}/programme${options.isSimple ? '?is_simple=1' : ''}`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        }
    })

export const getProgramme = (programmeId) =>
    fetch(`${API_URL}/programme/${programmeId}`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        }
    })

export const createProgramme = (programme) =>
    fetch(`${API_URL}/programme`, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        },
        body: JSON.stringify(programme)
    })

export const updateProgramme = (programmeId, programme) =>
    fetch(`${API_URL}/programme/${programmeId}`, {
        method: 'PUT',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        },
        body: JSON.stringify(programme)
    })

export const deleteProgrammes = (programmeIds) =>
    fetch(`${API_URL}/programme/batch-delete`, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        },
        body: JSON.stringify({ programmeIds })
    })

export const getProgrammeOverallDistribution = (queries) =>
    fetch(`${API_URL}/programme/overall-distribution?${queryStringBuilder(queries)}`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        }
    })

export const getProgrammeChannelDistribution = (queries) =>
    fetch(`${API_URL}/programme/channel-distribution?${queryStringBuilder(queries)}`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        }
    })

export const getCourseCodes = () =>
    fetch(`${API_URL}/course-code`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        }
    })

export const deleteCourseCode = (courseCodeId) =>
    fetch(`${API_URL}/course-code/${courseCodeId}`, {
        method: 'DELETE',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        },
    })

export const getProgrammeCategories = () =>
    fetch(`${API_URL}/programme-category`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        }
    })

export const deleteProgrammeCategory = (programmeCateogryId) =>
    fetch(`${API_URL}/programme-category/${programmeCateogryId}`, {
        method: 'DELETE',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        },
    })

export const getCenters = () =>
    fetch(`${API_URL}/center`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        }
    })

export const deleteCenter = (centerId) =>
    fetch(`${API_URL}/center/${centerId}`, {
        method: 'DELETE',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        },
    })

export const getInstitutes = () =>
    fetch(`${API_URL}/institute`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        }
    })

export const deleteInstitute = (instituteId) =>
    fetch(`${API_URL}/institute/${instituteId}`, {
        method: 'DELETE',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        },
    })


// WEBPACK FOOTER //
// ./src/services/api/programme.js